export const INTERVAL = {
  DAY: 'day',
  MONTH: 'month',
  YEAR: 'year'
}
